import { useQuery } from '@tanstack/react-query';
import { userService } from '../services/user.service';
import type { TenantUser } from '../services/user.service';

export function useTenantUsers(options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<TenantUser[]>({
    queryKey: ['tenantUsers'],
    queryFn: () => userService.listTenantUsers(),
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes - users change infrequently
  });
}
